import React, { useContext, useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "../../services/api";
import { HeyatYoluContext } from "../../App";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import yasinSurah from "../../services/Yasinsurah";
import "./styles/ProfileDetails.css";

function ProfileDetails() {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  // ← DƏYİŞDİ: default olaraq bağlı — əks halda himn girişdə dərhal dayandırılırdı
  const [showQuran, setShowQuran] = useState(false);
  const [showBible, setShowBible] = useState(false);
  const [showTorah, setShowTorah] = useState(false);
  const [showDocModal, setShowDocModal] = useState(false);
  const [confirmingId, setConfirmingId] = useState(null);

  // ← DƏYİŞDİ: Audio obyekti yalnız bir dəfə yaradılır (əvvəl hər render-də yeni Audio yaranırdı)
  const himnAudioRef = useRef(null);
  if (!himnAudioRef.current) {
    himnAudioRef.current = new Audio("../media/himn.mp3");
  }
  const yasinAudioRef = useRef(null);
  const religiousOpenRef = useRef(false);

  const [touchStart, setTouchStart] = useState(null);
  const touchStartRef = useRef(null);
  const scrollContainerRef = useRef(null);

  const { user, paymentAmount } = useContext(HeyatYoluContext);
  const [newMessage, setNewMessage] = useState("");
  const [condolences, setCondolences] = useState([]);

  const isActiveMartyr = !!(profile?.isMartyr && profile?.isConfirmed);
  const anyReligiousOpen = showQuran || showBible || showTorah;

  useEffect(() => {
    axios.get(`/memorialprofile/${id}`)
      .then((res) => {
        setProfile(res.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.status === 404) {
          console.log(`ℹ️ Profil tapılmadı: ID ${id}`);
        } else {
          console.log("⚠️ Profil yüklənərkən xəta:", err.message);
        }
        setError(err.response?.status || 500);
        setLoading(false);
      });

    axios.get(`/condolence/${id}`)
      .then(res => setCondolences(res.data))
      .catch(err => {
        console.log("ℹ️ Başsağlığı yoxdur");
        setCondolences([]);
      });
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;

    try {
      await axios.post(`/condolence`, {
        memorialProfileId: parseInt(id),
        text: newMessage
      });

      setCondolences(prev => [
        {
          text: newMessage,
          createdAt: new Date().toISOString(),
          userFullName: user.fullName
        },
        ...prev
      ]);
      setNewMessage("");
      toast.success("Başsağlığı göndərildi");
    } catch (err) {
      console.log("Başsağlığı göndərilə bilmədi:", err.message);
      toast.error("Başsağlığı göndərilə bilmədi");
    }
  };

  const handleDeleteRequest = (id) => {
    setConfirmingId(id);
  };

  const handleConfirmDelete = async (id) => {
    try {
      await axios.delete(`/condolence/${id}`);
      setCondolences(prev => prev.filter(c => c.id !== id));
      toast.success("Başsağlığı silindi");
    } catch (err) {
      toast.error("Silinmə zamanı xəta baş verdi.");
    } finally {
      setConfirmingId(null);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    toast.success("Link kopyalandı!");
  };

  const startPayment = async (profileId) => {
    if (!profileId || !user?.id || !paymentAmount) {
      toast.error("Ödəniş məlumatları tapılmadı");
      return;
    }

    try {
      toast.info("Ödəniş səhifəsinə yönləndirilirsiniz...");

      const response = await axios.post("/payment/create-payriff-order", {
        amount: paymentAmount,
        profileId,
        userId: user.id
      });

      const paymentUrl = response.data?.paymentUrl;
      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        throw new Error("Payment URL not received");
      }
    } catch (error) {
      console.log("Ödəniş xətası:", error.message);
      const errorMessage = error.response?.data?.message || "Ödəniş zamanı xəta baş verdi";
      toast.error(errorMessage);
    }
  };

  const formatTimeAgo = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diffMs = now - date;

    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);
    const diffWeek = Math.floor(diffDay / 7);
    const diffMonth = now.getMonth() - date.getMonth() + 12 * (now.getFullYear() - date.getFullYear());

    if (diffSec < 60) return "bir neçə saniyə əvvəl";
    if (diffMin < 60) return `${diffMin} dəqiqə əvvəl`;
    if (diffHour < 24) return `${diffHour} saat əvvəl`;
    if (diffDay === 1) return "1 gün əvvəl";
    if (diffDay < 7) return `${diffDay} gün əvvəl`;
    if (diffWeek < 5) return `${diffWeek} həftə əvvəl`;

    if (diffMonth < 12) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      return `${day}-${month}`;
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    document.body.style.overflow = selectedMedia ? 'hidden' : 'auto';
    return () => { document.body.style.overflow = 'auto'; };
  }, [selectedMedia]);

  const azMonthNames = [
    "yanvar", "fevral", "mart", "aprel", "may", "iyun",
    "iyul", "avqust", "sentyabr", "oktyabr", "noyabr", "dekabr"
  ];

  const formatAzDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = azMonthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const calculateAge = (birth, death) => {
    const dob = new Date(birth);
    const dod = new Date(death);
    let age = dod.getFullYear() - dob.getFullYear();
    const m = dod.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && dod.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  };

  const generateCondolenceText = (profile) => {
    const deathDate = formatAzDate(profile.dateOfDeath);
    const age = calculateAge(profile.dateOfBirth, profile.dateOfDeath);
    const religion = profile.religion ? profile.religion.toLowerCase() : "";

    if (profile.isMartyr) {
      let martyrText = `${deathDate} tarixində ${age} yaşında vətənin azadlığı və bütövlüyü uğrunda canını fəda etmiş igid şəhidimizin xatirəsini dərin hörmət və ehtiramla yad edirik.`;
      if (religion.includes("islam")) {
        martyrText += " Rəbbin ondan rəhmət eləməsi dilənir.";
      }
      return martyrText;
    }

    const baseText = `${deathDate} tarixində ${age} yaşında dünyasını dəyişdiyini, əzizlərinə, ailəsinə, doğmalarına və onu tanıyıb sevən hər kəsə dərin hüznlə bildiririk.`;
    if (religion.includes("islam")) {
      return `${baseText} Onun ruhu Firdavsa yüksəlsin, xatirəsi yad qalsın.`;
    }
    if (religion.includes("xristian")) {
      return `${baseText} Onun ruhu müqəddəs yerlərində dinc qalsın.`;
    }
    if (religion.includes("yəhudi")) {
      return `${baseText} Onun xatirəsi bəndləri qalsın, ruhu məbruk qalsın.`;
    }
    return baseText;
  };

  // ═══════════════ 🎵 HİMN / QURAN AUDIO MƏNTİQİ ═══════════════

  // Dini bölmənin açıq olub-olmadığını event listener-lər üçün ref-də saxla
  useEffect(() => {
    religiousOpenRef.current = anyReligiousOpen;
  }, [anyReligiousOpen]);

  // Girişdə himn oxunur; dini bölmə açılarsa dayanır, bağlanarsa davam edir
  useEffect(() => {
    const himn = himnAudioRef.current;

    if (!isActiveMartyr) {
      himn.pause();
      return;
    }

    himn.loop = false;
    himn.volume = 0.5;

    if (anyReligiousOpen) {
      himn.pause();
    } else {
      himn.play().catch(() => { });
    }
  }, [isActiveMartyr, anyReligiousOpen]);

  // Brauzer autoplay-i bloklayarsa (məs. QR-dan birbaşa giriş), ilk kliklə himni başlat
  useEffect(() => {
    if (!isActiveMartyr) return;
    const himn = himnAudioRef.current;
    const events = ["click", "keydown"];

    const removeListeners = () => {
      events.forEach(ev => document.removeEventListener(ev, unlock));
      himn.removeEventListener("playing", removeListeners);
    };

    function unlock(e) {
      // Quran/dini düyməyə klik — himni başlatma, sadəcə gözlə
      if (e.target?.closest?.(".pd-religious-section") || religiousOpenRef.current) return;
      if (himn.paused) himn.play().catch(() => { });
      removeListeners();
    }

    events.forEach(ev => document.addEventListener(ev, unlock));
    himn.addEventListener("playing", removeListeners);

    return removeListeners;
  }, [isActiveMartyr]);

  // Quran açılanda Yasin audiosu avtomatik başlayır
  useEffect(() => {
    if (showQuran) {
      himnAudioRef.current.pause();
      yasinAudioRef.current?.play().catch(() => { });
    }
  }, [showQuran]);

  // Səhifədən çıxanda himni tam dayandır
  useEffect(() => {
    const himn = himnAudioRef.current;
    return () => {
      himn.pause();
      himn.currentTime = 0;
    };
  }, []);

  // ═════════════════════════════════════════════════════════════

  const renderCeremonyInfo = (label, ceremony) => {
    if (!ceremony) return null;

    return (
      <div style={{ marginBottom: "12px" }}>
        <h5>{label}</h5>
        <p><strong>📅 Tarix:</strong> {formatAzDate((ceremony.date))}</p>
        {ceremony.location && <p><strong>📍 Yer:</strong> {ceremony.location}</p>}
        {ceremony.mapLink && (
          <p>
            <a href={ceremony.mapLink} target="_blank" rel="noopener noreferrer">
              🌐 Xəritədə bax
            </a>
          </p>
        )}
      </div>
    );
  };

  const capitalize = (text) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const handlePrevMedia = () => {
    if (selectedMediaIndex > 0) {
      const newIndex = selectedMediaIndex - 1;
      setSelectedMediaIndex(newIndex);
      setSelectedMedia(profile.media[newIndex]);
    }
  };

  const handleNextMedia = () => {
    if (selectedMediaIndex < profile.media.length - 1) {
      const newIndex = selectedMediaIndex + 1;
      setSelectedMediaIndex(newIndex);
      setSelectedMedia(profile.media[newIndex]);
    }
  };

  const handleTouchStart = (e) => {
    touchStartRef.current = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (!touchStartRef.current) return;

    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartRef.current - touchEndX;
    const minSwipe = 50;

    if (diff > minSwipe) {
      handleNextMedia();
    }

    if (diff < -minSwipe) {
      handlePrevMedia();
    }

    touchStartRef.current = null;
  };

  useEffect(() => {
    if (!selectedMedia) return;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        handlePrevMedia();
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        handleNextMedia();
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        setSelectedMedia(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedMedia, selectedMediaIndex, profile?.media]);

  if (loading) {
    return (
      <div className="pd-profile-loading">
        <div className="pd-skeleton-container">
          <div className="pd-skeleton pd-skeleton-image"></div>
          <div className="pd-skeleton pd-skeleton-title"></div>
          <div className="pd-skeleton pd-skeleton-text"></div>
          <div className="pd-skeleton pd-skeleton-text"></div>
          <div className="pd-skeleton pd-skeleton-block"></div>
        </div>
      </div>
    );
  }

  if (error || !profile) {
    return (
      <div className="pd-error-page">
        <div className="pd-error-container">
          <div className="pd-error-icon">🕊️</div>
          <h1 className="pd-error-title">Profil Tapılmadı</h1>
          <p className="pd-error-description">
            {error === 404
              ? "Axtardığınız profil mövcud deyil və ya silinib."
              : "Profil yüklənərkən xəta baş verdi. Zəhmət olmasa bir az sonra yenidən cəhd edin."
            }
          </p>
          <div className="pd-error-actions">
            <Link to="/" className="pd-btn-secondary-error">
              🏠 Ana Səhifəyə Get
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const isOwner = user && user.id === profile.createdByUserId;
  const needsPayment = !profile.isMartyr && !profile.isPaid;
  // ← YENİ: pulsuz rejimdə yaradılıb, admin təsdiqi gözləyir
  const needsConfirmation = !profile.isMartyr && profile.isPaid && !profile.isConfirmed;

  if (needsPayment && !isOwner) {
    return (
      <div className="pd-pending-payment-page">
        <div className="pd-pending-container">
          <div className="pd-pending-icon">⏳</div>
          <h1 className="pd-pending-title">Profil Hələ Aktivləşdirilməyib</h1>
          <p className="pd-pending-description">
            Bu profil ödəniş gözləyir və yalnız yaradıcısı tərəfindən görünə bilər.
          </p>
          <p className="pd-pending-hint">
            💡 Profil ödənişi tamamlandıqdan sonra burada açıq şəkildə görünəcək.
          </p>
          <div className="pd-pending-actions">
            <Link to="/" className="pd-btn-secondary-pending">
              🏠 Ana Səhifəyə Get
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (needsPayment && isOwner) {
    return (
      <>
        <div className="pd-owner-alert-banner">
          <div className="pd-alert-content">
            <div className="pd-alert-icon">⚠️</div>
            <div className="pd-alert-text">
              <h3>Profiliniz Aktivləşdirilməyib</h3>
              <p>
                Bu profil hazırda yalnız sizə görünür. Bütün istifadəçilər tərəfindən görünməsi üçün ödəməni tamamlayın.
              </p>
            </div>
            <div className="pd-alert-actions">
              <button
                onClick={() => startPayment(profile.id)}
                className="pd-btn-complete-payment"
              >
                💳 Ödəməni Tamamla ({paymentAmount} AZN)
              </button>
            </div>
          </div>
        </div>

        <div className="pd-preview-badge">
          <span>👁️</span> Ön Baxış Rejimi
        </div>

        <div className="pd-profile-details pd-preview-mode">
          {renderProfileContent()}
        </div>
      </>
    );
  }

  // ← YENİ: Təsdiq gözləyən profil — kənar ziyarətçilərə bağlı
  if (needsConfirmation && !isOwner) {
    return (
      <div className="pd-pending-payment-page">
        <div className="pd-pending-container">
          <div className="pd-pending-icon">⏳</div>
          <h1 className="pd-pending-title">Profil Təsdiq Gözləyir</h1>
          <p className="pd-pending-description">
            Bu profil hazırda admin tərəfindən yoxlanılır və yalnız yaradıcısı tərəfindən görünə bilər.
          </p>
          <p className="pd-pending-hint">
            💡 Admin təsdiqindən sonra profil burada açıq şəkildə görünəcək.
          </p>
          <div className="pd-pending-actions">
            <Link to="/" className="pd-btn-secondary-pending">
              🏠 Ana Səhifəyə Get
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // ← YENİ: Təsdiq gözləyən profil — sahibinə ön baxış + bildiriş
  if (needsConfirmation && isOwner) {
    return (
      <>
        <div className="pd-owner-alert-banner">
          <div className="pd-alert-content">
            <div className="pd-alert-icon">⏳</div>
            <div className="pd-alert-text">
              <h3>Profiliniz Admin Təsdiqini Gözləyir</h3>
              <p>
                Profiliniz uğurla yaradıldı və hazırda yalnız sizə görünür.
                Admin yoxlamasından sonra avtomatik olaraq yayımlanacaq.
              </p>
            </div>
          </div>
        </div>

        <div className="pd-preview-badge">
          <span>👁️</span> Ön Baxış Rejimi
        </div>

        <div className="pd-profile-details pd-preview-mode">
          {renderProfileContent()}
        </div>
      </>
    );
  }

  return renderProfileContent();

  function renderProfileContent() {
    const religion = profile?.religion?.toLowerCase() || "";

    return (
      <div className="pd-profile-details">
        <Helmet>
          <title>{profile.firstName} {profile.lastName} – HeyatYolu</title>
          <meta
            name="description"
            content={`${profile.firstName} ${profile.fatherName} ${profile.lastName} haqqında xatirə profili. ${calculateAge(profile.dateOfBirth, profile.dateOfDeath)} yaşında vəfat edib.`}
          />
          <meta
            property="og:title"
            content={`${profile.firstName} ${profile.lastName} – Xatirə Profili`}
          />
          <meta
            property="og:description"
            content={`${generateCondolenceText(profile).slice(0, 150)}...`}
          />
          <meta
            property="og:image"
            content={profile.photoUrl ? `https://api.heyatyolu.az${profile.photoUrl}` : "https://api.heyatyolu.az/placeholder.jpg"}
          />
        </Helmet>

        {profile.isMartyr && !profile.isConfirmed && (
          <div className="pd-pending-confirmation-banner">
            ⚠️ Bu profil şəhid kimi qeydə alınıb və admin tərəfindən təsdiq edildikdən sonra yayımlanacaq.
          </div>
        )}
        {profile.isMartyr && profile.isConfirmed && (
          <div className="pd-martyr-banner">
            🇦🇿 Şəhid — Vətən müstəqilliyi uğrunda canını fəda etmiş qəhrəman
          </div>
        )}
        {profile.isMartyr && profile.isConfirmed && (
          <>
            <img src="../media/flag4.png" className="pd-martyr-flag-left" alt="Bayraq" />
            <img src="../media/flag4.png" className="pd-martyr-flag-right" alt="Bayraq" />
          </>
        )}
        {profile.isMartyr && profile.isConfirmed && profile.martyrDocumentUrl && (
          <>
            <div
              className="pd-martyr-doc-thumbnail"
              onClick={() => setShowDocModal(true)}
            >
              📄
            </div>

            {showDocModal && (
              <div className="pd-martyr-doc-modal" onClick={() => setShowDocModal(false)}>
                <img
                  src={`https://api.heyatyolu.az${profile.martyrDocumentUrl}`}
                  alt="Şəhidlik sənədi"
                />
              </div>
            )}
          </>
        )}

        <h2>
          <i className="fas fa-ribbon"></i>{" "}
          {capitalize(profile.firstName)} {capitalize(profile.fatherName)} {capitalize(profile.lastName)}
        </h2>

        <img
          src={profile.photoUrl ? `https://api.heyatyolu.az${profile.photoUrl}` : "/placeholder.jpg"}
          alt="Profil şəkli"
          className="pd-main-photo"
        />

        <p style={{ textAlign: 'center', fontSize: '20px' }}>
          🗓️ {formatAzDate(profile.dateOfBirth)} – {formatAzDate(profile.dateOfDeath)} ({calculateAge(profile.dateOfBirth, profile.dateOfDeath)} yaş)
        </p>
        <p className="pd-condolence-text">🔗 {generateCondolenceText(profile)}</p>
        <div className="pd-profile-info-section">
          <div className="pd-info-row">
            <span className="pd-info-icon">📍</span>
            <strong>Doğulduğu yer:</strong>
            <span>{profile.birthPlace || "—"}</span>
          </div>

          <div className="pd-info-row">
            <span className="pd-info-icon">🕊️</span>
            <strong>Dəfn olunduğu yer:</strong>
            <span>{profile.deathPlace || "—"}</span>
          </div>

          <div className="pd-info-row">
            <span className="pd-info-icon">🛐</span>
            <strong>Dini:</strong>
            <span>{profile.religion || "—"}</span>
          </div>
        </div>

        {(profile?.threeDay?.date || profile?.sevenDay?.date || profile?.fortyDay?.date || profile?.anniversary?.date) && (
          <div className="pd-ceremony-container">
            <div className="pd-ceremony-title">🕯️ Mərasim Məlumatları</div>
            {renderCeremonyInfo("3-cü Gün Mərasimi", profile?.threeDay)}
            {renderCeremonyInfo("7-ci Gün Mərasimi", profile?.sevenDay)}
            {renderCeremonyInfo("40-cı Gün Mərasimi", profile?.fortyDay)}
            {renderCeremonyInfo("İl Dönümü Mərasimi", profile?.anniversary)}
          </div>
        )}

        <div className="pd-mourners-section">
          <h3>🕯️ Xatirəsini sevgi ilə yaşadanlar</h3>
          {profile.mourners.length > 0 ? (
            <p className="pd-mourners-inline">
              {profile.mourners.map((m, i) => (
                <span key={i}>
                  <strong>{m.relationType}</strong> – {m.fullName}{i < profile.mourners.length - 1 ? ', ' : ''}
                </span>
              ))}
            </p>
          ) : (
            <p className="pd-no-mourners">— Məlumat yoxdur —</p>
          )}
        </div>

        <div className="pd-biography-section">
          <h3>📖 Bioqrafiya</h3>
          <p>{profile.biography || "—"}</p>
        </div>


        {/* ═══════════════════════════════════════════════════════════
    🛐 RELIGIOUS CONTENT SECTION 
   ═══════════════════════════════════════════════════════════ */}

        {/* 🕌 ISLAMIC CONTENT */}
        {religion.includes("i̇slam") && (
          <div className="pd-religious-section pd-religion-islam">
            <div className="pd-religious-header">
              <span className="pd-religion-icon">🕌</span>
              <h3>İslam Dinində Yad Edilmə</h3>
            </div>

            <button onClick={() => setShowQuran(!showQuran)} className="pd-btn-religious">
              📖 {showQuran ? "Yasin Surəsini Bağla" : "Yasin Surəsini Oxu"}
            </button>
            {showQuran && (
              <div className="pd-religious-content pd-quran-text">
                <h4>🕋 Yasin Surəsi</h4>
                <p style={{ fontSize: '0.9rem', marginBottom: '1rem', color: '#666', fontStyle: 'italic' }}>
                  Müqəddəs Qurandan bir surə. Adətən vəfat edən şəxsin ruhuna bağışlanmaq və ailəsinə səbr diləmək üçün oxunur.
                </p>
                <audio
                  ref={yasinAudioRef}
                  controls
                  onPlay={() => himnAudioRef.current.pause()}
                  style={{ marginBottom: '1.5rem', width: '100%' }}
                >
                  <source src="../media/yasin.mp3" type="audio/mpeg" />
                  Sizin brauzer audio faylı dəstəkləmir.
                </audio>
                <div style={{ background: '#f9f9f9', padding: '1rem', borderRadius: '8px', maxHeight: '400px', overflowY: 'auto', lineHeight: '1.8' }}>
                  <p>{yasinSurah}</p>
                </div>
              </div>
            )}

            <div className="pd-religious-prayer">
              <p>🤲 <strong>Dua:</strong>
                "Allahım, onu bağışla, ona rəhm et, onu əfv et və onu Cənnətində dinc məkanına qəbul et.
                Qəbrini nurla doldur, axirət yolunu asanlaşdır. Amin."
              </p>
              <p style={{ fontSize: '0.9rem', marginTop: '1rem', color: '#555' }}>
                Bu dua vəfat edən şəxsin ruhuna rəhmət diləmək və onun ailəsinə təsəlli vermək məqsədilə oxunur.
              </p>
            </div>
          </div>
        )}

        {/* ✝️ CHRISTIAN CONTENT */}
        {religion.includes("xristian") && (
          <div className="pd-religious-section pd-religion-christian">
            <div className="pd-religious-header">
              <span className="pd-religion-icon">✝️</span>
              <h3>Xristian Dinində Yad Edilmə</h3>
            </div>

            <button onClick={() => setShowBible(!showBible)} className="pd-btn-religious">
              📖 Yəhya 11:25–26
            </button>
            {showBible && (
              <div className="pd-religious-content pd-bible-text">
                <h4>✝️ Müjdə Parçası</h4>
                <div className="pd-scripture-content">
                  <p style={{ fontWeight: '600', marginBottom: '1rem', color: '#c0392b' }}>Yəhya 11:25–26</p>
                  <p style={{ fontStyle: 'italic', lineHeight: '1.8', marginBottom: '1rem' }}>
                    "İsa dedi: Mən diriliş və həyatam. Mənə iman edən, ölmüş olsa belə yaşayacaq.
                    Və yaşayan, Mənə iman edən heç vaxt ölməyəcək. Buna inanırsanmı?"
                  </p>
                  <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '1rem' }}>
                    Bu ayələr Həzrət İsa Məsihin əbədi həyat və diriliş vədini bildirir.
                    Xristian inancına görə, Tanrıya iman gətirənlərin ruhu əbədi sülh içində yaşayır.
                  </p>
                </div>
              </div>
            )}

            <div className="pd-religious-prayer">
              <p>🙏 <strong>Dua:</strong>
                "Ey Uca Tanrı, mərhumun ruhunu Öz nurunla işıqlandır.
                Ona sənin hüzurunda əbədi rahatlıq ver. Amin."
              </p>
              <p style={{ fontSize: '0.9rem', marginTop: '1rem', color: '#555' }}>
                Xristian ənənəsində vəfat edən şəxs üçün dua etmək onun ruhuna sülh və ailəsinə təsəlli diləmək mənasındadır.
              </p>
            </div>
          </div>
        )}

        {/* ✡️ JEWISH CONTENT */}
        {religion.includes("yəhudi") && (
          <div className="pd-religious-section pd-religion-jewish">
            <div className="pd-religious-header">
              <span className="pd-religion-icon">✡️</span>
              <h3>Yəhudi Dinində Yad Edilmə</h3>
            </div>

            <button onClick={() => setShowTorah(!showTorah)} className="pd-btn-religious">
              📖 Kaddish Duası
            </button>
            {showTorah && (
              <div className="pd-religious-content pd-torah-text">
                <h4>✡️ Kaddish – Mərhum üçün Dua</h4>
                <div className="pd-scripture-content">
                  <p style={{ fontWeight: '600', marginBottom: '1rem', color: '#d68910' }}>Aramic dilində (əsli):</p>
                  <p style={{ fontStyle: 'italic', lineHeight: '1.8', marginBottom: '1.5rem', background: '#fffaf0', padding: '1rem', borderRadius: '6px' }}>
                    "Yitgadal veyitkadash shemeh rabbah..."
                  </p>

                  <p style={{ fontWeight: '600', marginBottom: '1rem', color: '#d68910' }}>Azərbaycan dilinə tərcümə:</p>
                  <p style={{ lineHeight: '1.8', marginBottom: '1.5rem', background: '#fff9f0', padding: '1rem', borderRadius: '6px' }}>
                    "Böyük və müqəddəs olsun Onun böyük adı bu dünyada.
                    Onun padşahlığı yaxın zamanda, bizim ömrümüzdə və bütün İsrail xalqı arasında bərqərar olsun. Amin."
                  </p>

                  <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '1rem' }}>
                    Kaddish duası Tanrının adını ucaldan və mərhumun xatirəsini yad edən dua sayılır.
                    Ənənəyə görə, yaxınları 11 ay boyunca bu duanı oxuyur.
                  </p>
                </div>
              </div>
            )}

            <div className="pd-religious-prayer">
              <p>✡️ <strong>Xatirə Sözü:</strong>
                "Onun xatirəsi bərəkətli olsun. Onun ruhu ailəsinə, İsrail xalqına və bütün insanlığa xeyir gətirsin."
              </p>
            </div>
          </div>
        )}

        {/* 🌍 ATHEIST/SECULAR CONTENT */}
        {(religion.includes("ateizm") || religion.includes("səkulyar")) && (
          <div className="pd-religious-section pd-religion-secular">
            <div className="pd-religious-header">
              <span className="pd-religion-icon">🌍</span>
              <h3>İnsani Dəyərlərdə Yad Edilmə</h3>
            </div>

            <div className="pd-religious-content pd-secular-text">
              <p><strong>💭 Həyat Dəyərləri:</strong></p>
              <p style={{ lineHeight: '1.8', marginBottom: '1.5rem' }}>
                Həyatın mənası insanın yaratdığı yaxşılıq, sevgi və xatirələrdədir.
                İnsan bədəncə ölsə də, onun təsiri və xeyirxahlığı başqalarının həyatında yaşamağa davam edir.
              </p>

              <p><strong>🌟 Hörmətin Ən Güclü Forması:</strong></p>
              <p style={{ lineHeight: '1.8', marginBottom: '1.5rem' }}>
                Onun dəyərlərinə sadiq qalmaq, sevdiyi insanlara dəstək olmaq,
                onun həyat hekayəsini gələcək nəsillərə çatdırmaq — bu, onun xatirəsini yaşatmağın ən gözəl yoludur.
              </p>

              <p><strong>🤝 Birlik və Xatirə:</strong></p>
              <p style={{ lineHeight: '1.8' }}>
                Onun haqqında danışmaq, onunla bağlı xatirələri paylaşmaq və insanlara etdiyi yaxşılıqları davam etdirmək –
                bu, ən mənalı hörmətdir.
              </p>
            </div>

            <div className="pd-religious-prayer">
              <p>💙 <strong>Hörmət Sözü:</strong>
                "Onun insanlığı, mərhəməti və xeyirxahlığı əbədi olaraq yaşasın.
                O, dünyanı daha yaxşı edən insanlar sırasında həmişə xatırlanacaq."
              </p>
            </div>
          </div>
        )}

        {/* 🙏 OTHER/MULTI-FAITH CONTENT */}
        {(!religion || religion.includes("diger") || religion.includes("multi")) &&
          !religion.includes("islam") &&
          !religion.includes("xristian") &&
          !religion.includes("yəhudi") &&
          !religion.includes("ateizm") && (
            <div className="pd-religious-section pd-religion-other">
              <div className="pd-religious-header">
                <span className="pd-religion-icon">🙏</span>
                <h3>Ümumbəşəri Hörmətlə Yad Edilmə</h3>
              </div>

              <div className="pd-religious-content pd-other-text">
                <p><strong>🕊️ Ümumbəşəri Hörmət:</strong></p>
                <p style={{ lineHeight: '1.8', marginBottom: '1.5rem' }}>
                  Hər dinin və hər inancın mərkəzində mərhəmət, sevgi və hörmət dayanır.
                  İnsanların inancı fərqli olsa da, xatirə və sevgi hamını birləşdirir.
                </p>

                <p><strong>🌸 Xatirə Yolu:</strong></p>
                <p style={{ lineHeight: '1.8', marginBottom: '1.5rem' }}>
                  Onun adını çəkmək, onun haqqında danışmaq və həyatında yaşatdığı dəyərləri qorumaq
                  ən gözəl yad etmə formasıdır.
                </p>

                <p><strong>🤝 Ruh Birliyi:</strong></p>
                <p style={{ lineHeight: '1.8' }}>
                  İnsanlıq bir bütündür. Dinlər fərqli olsa da, mərhumun ailəsinə dəstək olmaq və xatirəsini yaşatmaq
                  bütün dinlərin ortaq dəyərləridir.
                </p>
              </div>

              <div className="pd-religious-prayer">
                <p>🤲 <strong>Ümumi Dua:</strong>
                  "Rəbb, bütün insanlara mərhəmət və sülh bəxş et.
                  Vəfat edən bu insanın xatirəsi dünyada yaxşılıq və sevgi ilə yaşasın."
                </p>
              </div>
            </div>
          )}


        {/* ✅ ULTRA-MODERN LIGHTBOX */}
        {selectedMedia && (
          <div
            className="pd-lightbox"
            onClick={() => setSelectedMedia(null)}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <div className="pd-lightbox-wrapper" onClick={(e) => e.stopPropagation()}>
              <button
                className={`pd-nav-btn pd-nav-prev ${selectedMediaIndex === 0 ? 'pd-nav-disabled' : 'pd-nav-active'}`}
                onClick={() => handlePrevMedia()}
                disabled={selectedMediaIndex === 0}
                title="Əvvəlki (⬅️)"
              >
                <span className="pd-arrow-icon">‹</span>
              </button>

              <div className="pd-media-container">
                {selectedMedia.fileType === "image" ? (
                  <img
                    src={`https://api.heyatyolu.az${selectedMedia.url}`}
                    alt="Böyük şəkil"
                    className="pd-media-item"
                  />
                ) : (
                  <video
                    src={`https://api.heyatyolu.az${selectedMedia.url}`}
                    controls
                    autoPlay
                    className="pd-media-item"
                  />
                )}

                <button
                  className="pd-close-btn"
                  onClick={() => setSelectedMedia(null)}
                  title="Bağla (ESC)"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>

              <button
                className={`pd-nav-btn pd-nav-next ${selectedMediaIndex === profile.media.length - 1 ? 'pd-nav-disabled' : 'pd-nav-active'}`}
                onClick={() => handleNextMedia()}
                disabled={selectedMediaIndex === profile.media.length - 1}
                title="Sonrakı (➡️)"
              >
                <span className="pd-arrow-icon">›</span>
              </button>

              <div className="pd-counter">
                <span className="pd-counter-current">{selectedMediaIndex + 1}</span>
                <span className="pd-counter-slash">/</span>
                <span className="pd-counter-total">{profile.media.length}</span>
              </div>
            </div>
          </div>
        )}

        {/* ✅ MODERN HORIZONTAL SCROLL GALLERY */}
        {profile.media && profile.media.length > 0 && (
          <section className="pd-media-section">
            <>
              <div className="pd-media-header">
                <h3>📸 Xatirə Albomu</h3>
                <span className="pd-media-count">{profile.media.length} şəkil/video</span>
              </div>

              <div className="pd-media-scroll-wrapper">
                <div className="pd-media-scroll-container" ref={scrollContainerRef}>
                  {profile.media.map((item, index) => (
                    <div
                      key={index}
                      className="pd-media-item-card"
                      onClick={() => {
                        setSelectedMedia(item);
                        setSelectedMediaIndex(index);
                      }}
                    >
                      <div className="pd-media-thumbnail">
                        {item.fileType === "image" ? (
                          <img
                            src={`https://api.heyatyolu.az${item.url}`}
                            alt={`Media ${index + 1}`}
                            className="pd-thumb-img"
                          />
                        ) : (
                          <video
                            src={`https://api.heyatyolu.az${item.url}`}
                            className="pd-thumb-video"
                          />
                        )}
                      </div>
                      <span className="pd-thumb-type">
                        {item.fileType === "image" ? "🖼️ Şəkil" : "🎥 Video"}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="pd-scroll-fade-left"></div>
                <div className="pd-scroll-fade-right"></div>
              </div>

              <p className="pd-media-hint">💡 Soldan sağa sürükləyin / Klik edərək böyüdün</p>
            </>
          </section>
        )}

        <div className="pd-condolence-section">
          <h3>🕊️ Başsağlığı Mesajları</h3>

          <div className="pd-condolence-list-scroll">
            {condolences.length > 0 ? (
              condolences.map((c, idx) => (
                <div key={idx} className="pd-condolence-item">
                  <p>
                    <strong>{c.userFullName}</strong>: {c.text}
                  </p>
                  <small>{formatTimeAgo(c.createdAt)}</small>

                  {(user?.id === c.userId || user?.id === profile.createdByUserId) && (
                    <>
                      {confirmingId === c.id ? (
                        <div className="pd-confirm-popup">
                          <span>Əminsiniz?</span>
                          <button onClick={() => handleConfirmDelete(c.id)}>Bəli</button>
                          <button onClick={() => setConfirmingId(null)}>Xeyr</button>
                        </div>
                      ) : (
                        <button
                          onClick={() => handleDeleteRequest(c.id)}
                          className="pd-delete-condolence-btn"
                        >
                          ❌ Sil
                        </button>
                      )}
                    </>
                  )}
                </div>
              ))
            ) : (
              <p className="pd-no-condolence">Başsağlığı mesajı yoxdur.</p>
            )}
          </div>

          {user ? (
            <form onSubmit={handleSubmit} className="pd-condolence-form">
              <textarea
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Başsağlığı mesajınızı yazın..."
                rows={3}
                required
              ></textarea>
              <button type="submit">Göndər</button>
            </form>
          ) : (
            <p className="pd-login-required">Başsağlığı mesajı göndərmək üçün zəhmət olmasa daxil olun.</p>
          )}
        </div>

        {profile.qrCodeUrl && (
          <div className="pd-qr-section-profile">
            <div className="pd-qr-container">
              <div className="pd-qr-header">
                <p>QR kodu qəbir daşı üzərində və ya xatirə məkanlarında yerləşdirin.</p>
              </div>
              <div className="pd-qr-code-wrapper">
                <img
                  src={`https://api.heyatyolu.az/${profile.qrCodeUrl}`}
                  alt="QR Code"
                  className="pd-qr-image"
                />
              </div>
              <p className="pd-qr-description">
                QR kodu mobil telefonla skan edərək bu xatirə profilinə daxil olun.
              </p>
              <div className="pd-qr-actions">
                <a
                  href={`https://api.heyatyolu.az/${profile.qrCodeUrl}`}
                  download={`${profile.firstName}_${profile.lastName}_QR.png`}
                  className="pd-qr-download-btn"
                >
                  <span>💾</span> QR Kodu Yüklə
                </a>
                <button
                  onClick={handleCopyLink}
                  className="pd-qr-share-btn"
                >
                  <span>🔗</span> Linki Kopyala
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ProfileDetails;